import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "../../hooks/useTranslation";
import { motion } from "framer-motion";

export default function CareerBody() {
    const t = useTranslation();

    const fadeUp = i => ({
        hidden: { opacity: 0, y: 40 },
        show: { opacity: 1, y: 0, transition: { delay: i * .05, duration: .4 } }
    });

    return (
        <motion.div
            variants={fadeUp()}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-50px" }}
        >
            <Container className="career-container">
                {/* Intro */}
                <Row className="justify-content-center text-center career-intro-row px-4">
                    <Col lg={12}>
                        <h2 className="career-subtitle">{t("career.subtitle")}</h2>
                        <p className="career-intro">{t("career.intro")}</p>
                    </Col>
                </Row>

                {/* Positions */}
                <Row className="career-section-header p-4">
                    <Col>
                        <h3 className="career-section-title">{t("career.positionsTitle")}</h3>
                    </Col>
                </Row>

                <Row className="career-positions-row">
                    {/* Personal Trainer */}
                    <Col lg={12} xl={6} className="px-4">
                        <article className="career-card">
                            <h4 className="career-card-title">
                                {t("career.positions.trainer.title")}
                            </h4>
                            <p>{t("career.positions.trainer.desc")}</p>
                            <p className="career-note">
                                {t("career.positions.trainer.info")}
                            </p>
                            <p className="career-note">
                                {t("career.positions.trainer.exception")}
                            </p>
                        </article>
                    </Col>

                    {/* Cleaner */}
                    <Col lg={12} xl={6} className="p-4">
                        <article className="career-card">
                            <h4 className="career-card-title">
                                {t("career.positions.cleaner.title")}
                            </h4>
                            <p>{t("career.positions.cleaner.desc")}</p>
                        </article>
                    </Col>
                </Row>

                {/* Application */}
                <Row className="career-apply-row p-4">
                    <Col>
                        <h3 className="career-section-title">{t("career.applyTitle")}</h3>
                        <p>{t("career.applyDesc")}</p>
                        <p>
                            <a
                                href="mailto:roygym2024@gmail.com"
                                className="career-email"
                            >
                                roygym2024@gmail.com
                            </a>
                        </p>
                        <p className="career-phoneDesc">{t("career.phoneDesc")}</p>
                        <ul className="list-unstyled career-phone-list">
                            <li>
                                <a href="tel:+36304919340">+36 30 491 9340</a>
                            </li>
                            <li>
                                <a href="tel:+36309592613">+36 30 959 2613</a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </motion.div>
    );
}